import { Component, inject } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { SwUpdate } from '@angular/service-worker'

@Component({
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [RouterOutlet],
})
export class AppComponent {
  constructor() {
    inject(SwUpdate).versionUpdates.subscribe((event) => {
      if (event.type === 'VERSION_READY' && confirm('New version available. Reload?')) {
        window.location.reload()
      }
    })
  }
}
